<template>
  <v-app>

      <AppSidebar v-if="login_info && is_show_sidebar"></AppSidebar>
      <v-main v-if="login_info && is_show_sidebar">
        <v-container fluid style="height: 100%;">
          <router-view :key="$route.fullPath"></router-view>
        </v-container>
      </v-main>
      <router-view v-else></router-view>
      <vtoast ref="vtoast"/>
  </v-app>
</template>

<script>
import AppSidebar from './AppSidebar.vue'
import vtoast from '@/components/Utils/VToast.vue'
import store from '@/store/index.js' 
export default {
  name: 'AppLayout',

  components: {
     AppSidebar,vtoast
  },

  data: () => ({
    is_auth: false,
    store
    //
  }),
  computed: {
    login_info(){
      return this.$store.getters.login_info;
    },
    is_show_sidebar(){
      if (this.$route.meta.is_show_sidebar === false) {
        return false
      }
      else {
        return true
      }
    }
  },
  mounted: function(){
    this.$root.vtoast = this.$refs.vtoast
  }
};
</script>
<style>
.text_primary{
  color: #008edd !important;
}
.text_default {
  color: #666 !important;
}

.btn_default {
  border:1px solid #ccc !important;
}

.btn_default_bg_linear{
  background: linear-gradient(180deg,#fff,#f0f0f0) !important;
}

.btn_action {
  color: #FFF !important;
  border: 1px solid #0f88c5 !important;
}
.btn_action_bg_linear {
  background: linear-gradient(180deg,#20a6f2,#1092d3) !important;
}
.btn-danger{
  background: #e3262e;
  background-image: linear-gradient(180deg,#e3262e,#ab171e);
  border-radius: 4px;
  color: #fff !important;
  border: 1px solid #ab171e;
  text-decoration: none;
  min-width: 40px;
  /* margin-bottom: 5px; */
  box-shadow: inset 0 1px 1px #ff7b81, 0 2px 2px -1px rgba(0,0,0,.2);
}

.gap {
  gap: 12px;
}
</style>
